import React from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";

const SuccessFeedbackDialog = ({
  open,
  onOk,
  title,
  message,
  confirmText = "Ok",
  confirmColor = "#28A745",
  icon,
}) => {
  const dismiss = () => {
    if (onOk) onOk();
  };

  return (
    <Dialog
      open={open}
      onClose={dismiss}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent
        sx={{
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          p: 3,
        }}
      >
        {icon != null && (
          <Box
            sx={{
              width: 84,
              height: 84,
              backgroundColor: confirmColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              marginBottom: 2.5,
            }}
          >
            {icon}
          </Box>
        )}

        <Typography variant="h5" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>
          {title}
        </Typography>

        {message ? (
          <Typography
            sx={{
              fontFamily: "Rubik",
              color: "#0b3d87",
              fontSize: "14px",
              maxWidth: "400px",
              marginTop: 1,
              marginBottom: 2,
            }}
          >
            {message}
          </Typography>
        ) : null}

        <DialogActions sx={{ display: "flex", justifyContent: "center", width: "100%", mt: 1, p: 0 }}>
          <Button
            onClick={dismiss}
            sx={{
              fontFamily: "Rubik",
              backgroundColor: confirmColor,
              color: "white",
              fontWeight: "bold",
              padding: "8px 20px",
              borderRadius: "20px",
              "&:hover": { backgroundColor: confirmColor, filter: "brightness(0.92)" },
            }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessFeedbackDialog;
